import styled from 'styled-components';
import { Caption, body2, colors, heading3, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const Container = styled.div`
  padding: ${spacing.threeQuarter} ${spacing.plusHalf};
`;

export const ValueText = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${spacing.half};
`;

export const Value = styled.span`
  ${heading3};
  margin-top: 0;

  &[data-variant='info'] {
    /* default styles */
  }

  &[data-variant='warning'] {
    color: ${colors.textWarning};
  }

  &[data-variant='unknown'] {
    color: ${colors.textSecondary};
  }
`;

export const SecondaryValue = styled.span`
  ${body2};
  color: ${colors.textSecondary};
`;

export const Heading = styled.div`
  align-items: center;
  display: flex;
  height: ${pxToRem(28)};

  & > *:not(:first-child) {
    margin-left: ${spacing.half};
    margin-right: 0;
  }
`;

export const Label = styled.span`
  ${body2};
  color: ${colors.textSecondary};
  white-space: nowrap;
`;

export const CaptionText = styled(Caption)`
  color: ${colors.textSecondary};
`;
